import script from "./SupportingDocumentsPreviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportingDocumentsPreviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./SupportingDocumentsPreviewComponent.vue?vue&type=style&index=0&id=c3a32902&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a32902"]])

export default __exports__